<template>
  <div
    class="Tabs d-flex flex-grow-1 flex-shrink-1"
    :class="{ lastTabHasSeparator }"
  >
    <v-tabs
      v-model="internalCurrent"
      :fixed-tabs="hasFixedSize"
      :slider-size="sliderSize"
      class="d-flex flex-1"
      :centered="centered"
    >
      <v-tabs-slider :color="sliderColor" />
      <v-tab
        v-for="(tab, index) in tabs"
        :key="index"
      >
        {{ tab }}
        {{ totalElement !== null ? ` (${totalElement[index]})` : '' }}
      </v-tab>
    </v-tabs>
  </div>
</template>

<script type="text/javascript">
  import { SLIDER_SIZES } from '@/components/ui/common/Tabs/Tabs.const'
  import getColor from '@/utils/getColor.js'

  export default {
    model: {
      prop: 'current',
      event: 'input',
    },
    props: {
      tabs: {
        type: Array,
        required: true,
      },
      current: {
        type: Number,
        required: true,
      },
      isThick: {
        type: Boolean,
        default: false,
      },
      hasFixedSize: {
        type: Boolean,
        default: false,
      },
      lastTabHasSeparator: {
        type: Boolean,
        default: false,
      },
      centered: {
        type: Boolean,
        default: false,
      },
      sliderColor: {
        type: [String, null,],
        default: getColor('_004f9f'),
      },
      totalElement: {
        type: Array,
        default: null,
      },
    },
    computed: {
      internalCurrent: {
        get() {
          return this.current
        },
        set(value) {
          this.$emit('input', value)
        },
      },
      sliderSize() {
        return this.isThick ? SLIDER_SIZES.thick : SLIDER_SIZES.default
      },
    },
  }
</script>

<style lang="scss">
.Tabs {
  .v-tabs-bar {
    background-color: $color-transparent !important;
  }
  &.lastTabHasSeparator {
    .v-tabs-bar__content {
      & > div.v-tab:nth-last-child(2) {
        margin-right: 24px;
      }

      & > div.v-tab:nth-last-child(1) {
        position: relative;
        margin-left: 24px;

        &:after {
          content: '';
          position: absolute;
          left: -24px;
          height: 32px;
          width: 1px;
          background-color: $color-004f9f;
        }
      }
    }
  }
  .v-tabs {
    .v-item-group {
      display: flex;
      flex: 1 1 auto;
      width: 0;
      .v-tabs-slider-wrapper {
        justify-content: center;
        display: flex;
      }
      .v-slide-group__content {
        border-bottom: 1px solid rgba(1, 76, 129, 0.16);
      }
    }
    .v-tab {
      text-transform: initial !important;
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 0.24px;
      line-height: 24px;
      padding-bottom: 5px;

      &:not(.v-tab--active) {
        color: $color-9e9fa2 !important;
      }

      &.v-tab--active {
        color: $color-004f9f !important;
      }
    }
  }
}
</style>
